<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้ของวันนี้"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้ของวันนี้</p>
                    <b>{{this.cardData.all_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้รวม (หักค่าบริการ)"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้รวม (หักค่าบริการ)</p>
                    <b>{{this.cardData.promptpay_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="ค่าบริการ"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">ค่าบริการ</p>
                    <b>{{this.cardData.promptpay_service_charge}} ฿</b>

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="รายได้สุทธิ / วัน"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                    <p style="font-size: 14px">รายได้สุทธิ / วัน</p>
                    <b>{{this.cardData.today_profit}} ฿</b>

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <projects-table title="Promotion"></projects-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ProjectsTable from './Tables/PromotionTable'

  import JwService from '../service/justwash';

  export default {
    name: 'protables',
    components: {
      ProjectsTable
    },
    data() {
      return {
        cardData: {}
      };
    },
    mounted() {
       this.$isLoading(true)

      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.Dashboard',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {

           this.$isLoading(false)
          this.cardData = response.data.message.data
          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.cardData);
          // console.log(response.data.message.data);
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });
    }
  };
</script>
<style></style>